module.exports = __webpack_public_path__ + "static/media/993816.2b1eed18.png";